import { render, staticRenderFns } from "./HomeCertificate.vue?vue&type=template&id=546bac50&scoped=true"
import script from "./HomeCertificate.vue?vue&type=script&lang=js"
export * from "./HomeCertificate.vue?vue&type=script&lang=js"
import style0 from "./HomeCertificate.vue?vue&type=style&index=0&id=546bac50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bac50",
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg})
